import React, { useEffect, useState } from 'react'
import axiosInstance from '../services/axiosComman';

function useGetCompanyInfo() {
    const [company,setCompany]=useState({})
    async function getCompanyInfo() {
        await axiosInstance.get(`/company-info/`).then((res) => {
            if(res?.data?.data[0]){
             setCompany(res?.data?.data[0]);
            }
        });
      }

  useEffect(()=>{
    getCompanyInfo()
  },[])
  return {company}
}

export default useGetCompanyInfo